import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import Grid from '../../../component/form/Grid';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import DataFormView from '../../../component/form/v2/DataFormView';
import gql from 'graphql-tag';
import { flattenConnection } from '../../../util/graphql';
import { validationHelper } from '../../../util/validation';
import EditValuables, { convertLegacyValuablesNotes } from './EditValuable';
import { isNullOrUndefined } from '../../../util/objects';
import { DiamondIcon } from '../../../component/IconIndex';
import Hidden from '../../../component/Hidden';

class SimpleValuableDetailsModal extends Component {
    render() {
        const { form, tabProps } = this.props;
        return (
            <Grid container>
                <EditValuables form={form} noChanging={tabProps.noChanging} />
            </Grid>
        );
    }
}

const styles = ({ palette, breakpoints, spacing, funeralHome }) => ({
    smallerButton: {
        marginRight: 15,
        '& > span': {
            fontSize: 10
        }
    },
    viewRoot: {
        padding: `${spacing(3)} 0`,
        paddingBottom: 0
    },
    diagRoot: {
        maxWidth: '700px'
    },
    diagHeader: {
        background: palette.contentForeground[funeralHome],
        padding: spacing(3)
    },
    diagHeaderTitle: {
        color: '#FFFFFF',
        fontSize: '16px',
        fontWeight: 'lighter',
        lineHeight: 'normal'
    },
    diagHeaderSubtitle: {
        color: '#FFFFFF',
        fontSize: '36px',
        fontWeight: 'initial',
        lineHeight: 'normal'
    },
    diagHeaderIcon: {
        width: '70px',
        height: '70px',
        float: 'right',
        color: 'rgba(255,255,255,0.5)'
    },
    footerButtons: {
        position: 'absolute',
        bottom: 0,
        padding: 10,
        display: 'flex',
        justifyContent: 'space-between',
        left: 10,
        right: 10,
        [breakpoints.down('sm')]: {
            left: 0,
            right: 0
        }
    },
    saveButtonContainer: {
        marginLeft: 10,
        position: 'static',
        minWidth: 'unset'
    },
    saveButton: {
        [breakpoints.down('sm')]: {
            minWidth: 'unset',
            bottom: 0,
            right: 0,
            padding: '10px',
            borderRadius: 64,
            height: 'fit-content',
            '& span > span': {
                display: 'block'
            },

            '& span > svg': {
                display: 'block',
                margin: 0,
                height: 20,
                width: 20,
                marginRight: 12
            }
        }
    }
});

const SimpleValuableDetailsModalFragment = gql`
    fragment SimpleValuableDetailsModalFragment on FuneralValuableItem {
        ID
        Description
        Signed
        ToBePlaced
        Quantity
        CurrentLocation
        CurrentLocationDetail
        ToBeReturned
        WhereToBeReturned
        FinalAction
        Note
        Funeral {
            ID
            MortuaryWatchData
            MortuaryWatchChanged
        }
        Changes {
            edges {
                node {
                    ID
                    UserName
                    Created
                    Status
                    Location
                    LocationDetail
                }
            }
        }
    }
`;

const Tabs = [
    {
        id: 'SimpleValuableDetailsModal',
        label: 'SimpleValuableDetailsModal',
        component: withStyles(styles)(SimpleValuableDetailsModal),
        fragment: SimpleValuableDetailsModalFragment,
        onLoad: data => {
            convertLegacyValuablesNotes(data);
            if (data.Changes) flattenConnection(data, 'Changes');
        },
        formatSaveData: (saveData, state) => {
            delete saveData.Changes;
            // always reattach to funeral so it's in the changelog
            saveData.Funeral = {
                ID: state.FuneralID || (state.Funeral && state.Funeral.ID),
                MortuaryWatchChanged: null // force update
            };
        },
        validation: {
            required: ['Description'],
            //suggested: ['Description']
            onValidate: {
                CurrentLocation: (newValue, persistedValue, hasValue, getField) => {
                    return isNullOrUndefined(persistedValue) ? validationHelper.required() : validationHelper.ok();
                },
                Quantity: (newValue, persistedValue, hasValue, getField) => {
                    return isNullOrUndefined(persistedValue) || Number(persistedValue) < 1
                        ? validationHelper.required('Please enter a quantity greater than zero.')
                        : validationHelper.ok();
                }
            }
        }
    }
];

class SimpleValuableDetailsModalView extends Component {
    render() {
        const { context, itemId, parentId, onClose, onSaved, onCreateNew, open, classes, noChanging } = this.props;

        if (!open) return <span />;
        const isEdit = itemId > 0;
        const createNewValuableItem = () => {
            return {
                Description: null,
                Signed: null,
                ToBePlaced: null,
                Quantity: 0,
                CurrentLocation: null,
                CurrentLocationDetail: null,
                ToBeReturned: false,
                WhereToBeReturned: null,
                Changes: [],
                FinalAction: null,
                Note: null,
                Funeral: {
                    ID: parentId,
                    MortuaryWatchData: null // reset purple validation
                }
            };
        };
        return (
            <Dialog disableEscapeKeyDown={true} open={open} classes={{ paper: classes.diagRoot }}>
                <DialogTitle className={classes.diagHeader}>
                    <Hidden smDown>
                        <DiamondIcon className={classes.diagHeaderIcon} />
                        <div className={classes.diagHeaderTitle}>{isEdit ? 'Edit' : 'Add'}</div>
                        <div className={classes.diagHeaderSubtitle}>Valuables Item</div>
                    </Hidden>
                    <Hidden smUp>
                        <div className={classes.diagHeaderTitle}>{isEdit ? 'Edit' : 'Add'} Valuables Item</div>
                    </Hidden>
                </DialogTitle>
                <DialogContent>
                    <DataFormView
                        tabProps={{ noChanging }}
                        tabs={Tabs}
                        createNew={isNullOrUndefined(itemId)}
                        createNewFunc={createNewValuableItem}
                        objectType="FuneralValuableItem"
                        itemId={itemId}
                        parentId={parentId}
                        parentObjectType="Funeral"
                        parentDataForm // prevent history.block only, don't reload parent
                        name="SimpleValuableDetailsModal"
                        context={context}
                        onClose={onClose}
                        onCreated={onCreateNew}
                        onUpdated={onSaved}
                        className={classes.viewRoot}
                        classes={{
                            footerButtons: classes.footerButtons,
                            footerButtonsContainer: classes.saveButtonContainer,
                            saveButton: classes.saveButton
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <div style={{ padding: 24 }}>{/* leaving space for buttons */}</div>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(SimpleValuableDetailsModalView);
